<template>
  <modal name="edit-request-modal" :height="'auto'" :width="'600'" :adaptive="true" :scrollable="true" :clickToClose="false">
    <div class="flex items-center justify-between p-4 border-b">
      <h4 class="text-base font-semibold">Talep Düzenle</h4>
      <button @click="$modal.hide('edit-request-modal')"><i class="fas fa-times"></i></button>
    </div>

    <div v-if="item" class="p-4 space-y-3">
      <!-- Talep Bilgileri -->
      <div class="bg-gray-50 rounded p-2 text-xs">
        <div><span class="text-gray-500">Plaka:</span> <span class="font-medium">{{ item.vehiclePlate }}</span></div>
        <div><span class="text-gray-500">Sürücü:</span> <span class="font-medium">{{ item.driverName }}</span></div>
      </div>

      <!-- İstasyon (status 3+) -->
      <div v-if="item.status >= 3">
        <label class="text-xs text-gray-600 mb-1 block">İstasyon</label>
        <select v-model="stationId" class="w-full border border-gray-300 rounded px-2 py-1 text-xs">
          <option :value="null">— Değiştirme —</option>
          <option v-for="s in stations" :key="s.id" :value="s.id">{{ s.name }} ({{ s.city }})</option>
        </select>
      </div>

      <!-- Kalemler -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <span class="text-xs font-semibold text-gray-700">Kalemler</span>
          <button class="text-xxs px-2 py-1 bg-blue-500 text-white rounded" @click="addItem">
            <i class="fas fa-plus mr-1"></i>Yeni Kalem
          </button>
        </div>

        <div class="space-y-2 max-h-72 overflow-y-auto">
          <div v-for="(it, idx) in items" :key="idx" class="border rounded p-2 bg-white">
            <div class="grid grid-cols-12 gap-2 items-end">
              <!-- Yakıt -->
              <div class="col-span-3">
                <label class="text-xxs text-gray-500">Yakıt</label>
                <div v-if="it.itemId" class="px-1 py-1 text-xs font-medium text-gray-700">
                  {{ it.fuelType }}
                  <span v-if="it.isFillTank" class="ml-1 px-1 py-0.5 text-white text-xxs rounded" style="background-color: #7c3aed;">TAM DOL.</span>
                </div>
                <select v-else v-model="it.fuelType" class="w-full border rounded px-1 py-0.5 text-xs">
                  <!-- Filo yalnızca dizel ve AdBlue kullanıyor (2026-09-18) -->
                  <option value="DIZEL">DIZEL</option>
                  <option value="ADBLUE">ADBLUE</option>
                </select>
              </div>

              <!-- Talep (Lt) -->
              <div class="col-span-3">
                <label class="text-xxs text-gray-500">Talep (Lt)</label>
                <div v-if="it.itemId" class="px-1 py-1 text-xs text-gray-600">
                  <span v-if="it.isFillTank" class="font-semibold" style="color: #7c3aed;">TAM DOLUM</span>
                  <span v-else>{{ it.requestedLiters }}</span>
                </div>
                <input v-else v-model.number="it.requestedLiters" type="number" min="0" class="w-full border rounded px-1 py-0.5 text-xs" :disabled="it.isFillTank" />
              </div>

              <!-- Onay (Lt) -->
              <div class="col-span-4">
                <label class="text-xxs text-gray-500">
                  Onay (Lt)
                  <span v-if="it.itemId && it.isFillTank" class="text-xxs text-purple-600">(boş = TAM DOLUM)</span>
                </label>
                <input
                  v-model.number="it.approvedLiters"
                  type="number"
                  min="0"
                  class="w-full border rounded px-1 py-0.5 text-xs"
                  :placeholder="it.itemId && it.isFillTank ? 'TAM DOLUM' : ''"
                />
              </div>

              <!-- Yeni kalem için Tam Dol checkbox -->
              <div v-if="!it.itemId" class="col-span-1">
                <label class="text-xxs text-gray-500 block">T.Dol</label>
                <input v-model="it.isFillTank" type="checkbox" />
              </div>

              <!-- Aksiyon -->
              <div class="col-span-1 flex justify-end">
                <button
                  v-if="!it.itemId"
                  class="text-red-500 hover:text-red-700"
                  @click="removeItem(idx)"
                  title="Yeni kalemi kaldır"
                >
                  <i class="fas fa-trash"></i>
                </button>
                <button
                  v-else
                  class="text-orange-500 hover:text-orange-700"
                  @click="rejectExistingItem(it)"
                  title="Bu kalemi iptal et (sürücü + istasyon bildirilir)"
                >
                  <i class="fas fa-ban"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="items.length === 0" class="text-center text-xs text-gray-400 py-3">Kalem yok. Yeni kalem ekleyiniz.</div>
        </div>
      </div>

     

      <!-- Butonlar -->
      <div class="flex space-x-2 pt-2 border-t">
        <button class="flex-1 px-3 py-2 bg-green-500 text-white text-xs rounded" :disabled="saving" @click="save">
          <i class="fas fa-save mr-1"></i>{{ saving ? 'Kaydediliyor...' : 'Kaydet' }}
        </button>
        <button class="flex-1 px-3 py-2 bg-gray-400 text-white text-xs rounded" @click="$modal.hide('edit-request-modal')">İptal</button>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
import { fuel } from "@/networking/urlmanager";

export default {
  name: "edit-request-modal",
  props: {
    item: { type: Object, default: null },
    stations: { type: Array, default: () => [] },
  },
  data() {
    return {
      saving: false,
      stationId: null,
      approvedLitersTotal: null,
      items: [],
    };
  },
  computed: {
    autoApprovedTotal() {
      return this.items.reduce((sum, it) => sum + (Number(it.approvedLiters) || 0), 0);
    },
  },
  methods: {
    addItem() {
      this.items.push({ fuelType: "DIZEL", requestedLiters: 0, approvedLiters: 0, isFillTank: false });
    },
    removeItem(idx) { this.items.splice(idx, 1); },
    rejectExistingItem(it) {
      if (!this.item) return;
      this.$swal.fire({
        title: "Kalemi İptal Et",
        html: `<b>${it.fuelType}</b> kalemi iptal edilecek.<br/>Bu işlem sürücüye ve istasyona bildirilecek.<br/><br/>İptal nedenini giriniz:`,
        input: "text",
        showCancelButton: true,
        confirmButtonText: "Kalemi İptal Et",
        cancelButtonText: "Vazgeç",
        inputValidator: (val) => !val ? "Lütfen iptal nedenini giriniz" : null,
      }).then((res) => {
        if (res.isConfirmed) {
          axios.post(fuel.requestItemReject, {
            requestId: this.item.id,
            itemId: it.itemId,
            rejectionReason: res.value,
          }, {
            headers: { Authorization: "Bareer " + this.$store.state.userData.token },
          })
            .then(() => {
              this.swalBox("success", "Kalem İptal Edildi", "Sürücü ve istasyona bildirim gönderildi.", false);
              // Kalemi listeden çıkar (UI)
              this.items = this.items.filter(x => x.itemId !== it.itemId);
              this.$emit("refresh");
            })
            .catch((err) => { this.errorBox(err.response); });
        }
      });
    },
    save() {
      if (!this.item) return;
      this.saving = true;
      const body = {
        requestId: this.item.id,
        items: this.items.map(it => {
          const base = {
            ...(it.itemId ? { itemId: it.itemId } : {}),
            fuelType: it.fuelType,
            requestedLiters: it.isFillTank ? null : (it.requestedLiters || null),
            isFillTank: !!it.isFillTank,
          };
          // Onay litresi: TAM DOLUM kalemi için boş = null (TAM DOLUM), sayı = limit
          // Normal kalem için: girilen değer
          if (it.approvedLiters == null || it.approvedLiters === "" || Number(it.approvedLiters) <= 0) {
            base.approvedLiters = null;
          } else {
            base.approvedLiters = Number(it.approvedLiters);
          }
          return base;
        }),
      };
      if (this.approvedLitersTotal != null && this.approvedLitersTotal !== "") {
        body.approvedLiters = Number(this.approvedLitersTotal);
      }
      if (this.stationId) body.stationId = this.stationId;

      axios.post(fuel.requestEdit, body, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          this.swalBox("success", "Güncellendi", "", false);
          this.$emit("refresh");
          this.$modal.hide("edit-request-modal");
        })
        .catch((err) => { this.errorBox(err.response); })
        .finally(() => { this.saving = false; });
    },
    syncFromItem() {
      if (!this.item) return;
      this.stationId = null;
      this.approvedLitersTotal = null;
      this.items = (this.item.items || []).map(it => ({
        itemId: it.id,
        fuelType: it.fuelType,
        requestedLiters: it.requestedLiters,
        // TAM DOLUM kalemi için approvedLiters null gelirse input boş kalsın (placeholder TAM DOLUM gösterir)
        approvedLiters: it.approvedLiters != null ? it.approvedLiters : "",
        isFillTank: !!it.isFillTank,
      }));
    },
  },
  watch: {
    item() { this.syncFromItem(); },
  },
};
</script>
